<template>
  <v-flex xs12>
    <v-layout row wrap>
      <v-flex xs12 sm8 offset-md2 class="expandableContainer">
        <v-form lazy-validation @submit.prevent="processForm">
          <v-container>
            <v-flex xs12>
               <v-layout row wrap justify-space-between>
                <v-flex xs12 sm8 offset-md2>
                  <v-select
                    item-text="typeLevel"
                    no-data-text="Selecciona un gateway para el las keys del pago."
                    :items="gateways"
                    return-object
                    @change="changeSelect"
                    v-model="paymentsKeysForm.gateway"
                    label="Gateway"
                  />
                </v-flex>
              </v-layout>
              <v-layout row wrap justify-space-between>
                <!-- <p>Key:</p> -->
                <v-flex xs12 sm8 offset-md2>
                  <v-text-field
                    :error-messages="processErrorPublic"
                    v-model="paymentsKeysForm.publicKey"
                    label="Public key"
                    required
                  />
                </v-flex>
              </v-layout>
              <v-layout row wrap justify-space-between>
                <v-flex xs12 sm8 offset-md2>
                  <v-text-field
                    :error-messages="processErrorSecret"
                    v-model="paymentsKeysForm.secretKey"
                    label="Secret key"
                    required
                  />
                </v-flex>
              </v-layout>
              <v-layout row wrap justify-space-between>
                <v-flex xs12 sm8 offset-md2>
                  <v-text-field
                    :error-messages="processErrorMerchant"
                    v-model="paymentsKeysForm.merchantId"
                    label="Merchant id"
                    required
                    v-show="seen"
                  />
                </v-flex>
              </v-layout>
            </v-flex>
          </v-container>
        </v-form>
      </v-flex>
    </v-layout>
  </v-flex>
</template>
<script>
import { required } from "vuelidate/lib/validators";
    export default {
        props: ["save"],
        validations() {
            if (this.paymentsKeysForm.gateway === "OPENPAY") {
              return {
                paymentsKeysForm: {
                    merchantId: { required },
                    publicKey: { required },
                    secretKey: { required }
                }
              };
            }

            return {
              paymentsKeysForm: {
                  publicKey: { required },
                  secretKey: { required }
              }
            };
        },
        data: () => ({
            seen: true,
            paymentsKeysForm:{
                id: 0,
                idBranch: 0,
                merchantId : "",
                publicKey: "",
                secretKey: "",
                gateway: ""
            },
            gateways: ["OPENPAY","NETPAY"]
        }),
        mounted() {
            this.getKeys();
        },
        computed: {
            processErrorMerchant() {
                const errors = [];
                if (!this.$v.paymentsKeysForm.merchantId || this.paymentsKeysForm.gateway !== "OPENPAY") {
                  return undefined;
                }

                if (!this.$v.paymentsKeysForm.merchantId.$dirty) return errors;
                !this.$v.paymentsKeysForm.merchantId.required && errors.push("El merchant id es requerido");
                return errors;
            },
            processErrorPublic() {
                const errors = [];
                if (!this.$v.paymentsKeysForm.publicKey.$dirty) return errors;
                !this.$v.paymentsKeysForm.publicKey.required && errors.push("El public key es requerido");
                return errors;
            },
            processErrorSecret() {
                const errors = [];
                if (!this.$v.paymentsKeysForm.secretKey.$dirty) return errors;
                !this.$v.paymentsKeysForm.secretKey.required && errors.push("El secret key es requerido");
                return errors;
            },
        },
        watch: {
            save() {
                if (this.save) {
                    this.processForm();
                }
            }
        },
        methods: {
            processForm() {
                this.$v.paymentsKeysForm.$touch();
                if (!this.$v.paymentsKeysForm.$invalid) {
                    var request = {
                        merchantId: this.paymentsKeysForm.merchantId,
                        publicKey: this.paymentsKeysForm.publicKey,
                        secretKey: this.paymentsKeysForm.secretKey,
                        gateway: this.paymentsKeysForm.gateway
                    };
                    this.$emit("loading", true);
                    this.$store
                    .dispatch("payments/savePaymentsKeys", request)
                        .then((response) => {
                          if (response.data.id) {
                            this.$emit("success");
                          } else {
                            this.$emit("error");
                          }
                        })
                        .catch(() => {
                          this.$emit("error");
                        }).finally(() => {
                          this.$emit("loading", false);
                        });
                } else {
                    this.$emit("cancel");
                }
            },
            getKeys() {
                this.$store
                    .dispatch("payments/getPaymentsKeys")
                    .then(response => {
                        this.paymentsKeysForm = response.data;
                        this.seen = this.paymentsKeysForm.gateway === "OPENPAY";
                    })
                    .catch(error => {
                        console.log(error);
                    });
            },
            changeSelect(val){
              if ("OPENPAY" == val) {
                this.seen = true;
              } else {
                this.seen = false;
                delete this.paymentsKeysForm.merchantId;
              }
            }
        }
    };
</script>
<style>
</style>